import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';

import { Tooltip } from '@/shared/components/ui/tooltip/tooltip';

import { StyledIconBgButton } from './icon-bg-button.styled';
import { TIconBgButtonProps } from './icon-bg-button.types';

export const IconBgButton: React.FC<TIconBgButtonProps> = ({
  variant,
  size,
  clicked,
  loading,
  disabled,
  tooltip,
  tooltipProps,
  children,
  ...props
}) => {
  return (
    <Tooltip title={tooltip} wrapper="default" {...tooltipProps}>
      <StyledIconBgButton
        $variant={variant}
        $size={size}
        $clicked={clicked}
        disabled={disabled || loading}
        {...props}
      >
        {loading ? <CircularProgress /> : children}
      </StyledIconBgButton>
    </Tooltip>
  );
};
